import { render, staticRenderFns } from "./uploadMore.vue?vue&type=template&id=0639061e&"
import script from "./uploadMore.vue?vue&type=script&lang=js&"
export * from "./uploadMore.vue?vue&type=script&lang=js&"
import style0 from "./uploadMore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports